type ProfileLike = {
  firstName?: string;
  middleName?: string;
  lastName?: string;
};

export const normalizeProfileLike = (params: ProfileLike) => {
  const { firstName = '', middleName = '', lastName = '' } = params;

  return {
    toFullName() {
      return [lastName, firstName, middleName]
        .reduce<string>((acc, piece) => {
          if (piece) {
            return `${acc} ${piece}`;
          }

          return acc;
        }, '')
        .trim();
    },
    toShortName() {
      return `${firstName} ${lastName}`.trim();
    },
    toShortestName() {
      const firstNameFirstLetter = firstName.slice(0, 1);

      const middleNameFirstLetter = middleName.slice(0, 1);

      return [firstNameFirstLetter, middleNameFirstLetter]
        .reduce<string>((acc, piece) => {
          if (piece) {
            return `${acc} ${piece}.`;
          }

          return acc;
        }, `${lastName}`)
        .trim();
    },
  };
};
